import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form } from 'react-bootstrap';
import { getFieldCatalog, listChannels } from './google-ads-audit-admin-api';

const MAX_ROWS = 500;

export const AdminCatalogBrowser = () => {
  const { data: channels = [] } = useQuery({
    queryKey: ['google-ads-audit-admin-channels'],
    queryFn: () => listChannels()
  });
  const [channelKey, setChannelKey] = useState('google_ads');
  const [search, setSearch] = useState('');

  const { data } = useQuery({
    queryKey: ['google-ads-audit-admin-catalog', channelKey],
    queryFn: () => getFieldCatalog(channelKey),
    enabled: Boolean(channelKey)
  });

  const filtered = useMemo(() => {
    const fields = data?.fields ?? [];
    const q = search.trim().toLowerCase();
    return (q ? fields.filter(f => f.fieldName.toLowerCase().includes(q)) : fields).slice(
      0,
      MAX_ROWS
    );
  }, [data, search]);

  return (
    <div className='google-ads-audit-admin-catalog'>
      <div className='google-ads-audit-form-row'>
        <Form.Select value={channelKey} onChange={e => setChannelKey(e.target.value)}>
          {channels.map(channel => (
            <option key={channel.key} value={channel.key}>
              {channel.label}
            </option>
          ))}
        </Form.Select>
        <Form.Control
          placeholder='Search fields'
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      {filtered.length === 0 ? (
        <p className='google-ads-audit-subtitle'>
          No fields catalogued yet. See{' '}
          <a href='https://developers.google.com/google-ads/api/fields/latest/overview'>
            Google&apos;s field reference
          </a>{' '}
          in the meantime.
        </p>
      ) : (
        <table className='google-ads-audit-admin-catalog-table'>
          <thead>
            <tr>
              <th>Field</th>
              <th>Type</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(field => (
              <tr key={field.id}>
                <td>{field.fieldName}</td>
                <td>{field.fieldType}</td>
                <td>{field.category}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
